import { useMutation } from "react-query";
import { useAuthentication } from "../useAuthentication.ts";

export const useMutationDeleteProject = () => {
  const { accessToken } = useAuthentication();

  return useMutation(
    async ({
      sourceId,
      projectId,
    }: {
      sourceId: string;
      projectId: string;
    }) => {
      const response = await fetch(
        `${
          import.meta.env.VITE_API_HOST
        }/sources/${sourceId}/projects/${projectId}`,
        {
          method: "DELETE",
          headers: {
            authorization: accessToken ?? "",
          },
        },
      );

      if (!response.ok) {
        throw new Error("Failed to delete project");
      }
    },
    {
      onError: (error, data) => {
        console.error("Failed to delete project", error, data);
      },
    },
  );
};
